<template>
  <ins class="adsbygoogle"
    :data-ad-client="adClient"
    :data-ad-slot="adSlot"
    :data-ad-format="adFormat"
    :style="adStyle"
    ad-data-full-width-responsive="true"></ins>
</template>

<script>
// Script AdSense chargé seulement quand une annonce s'affiche : jamais pour un compte premium.
const ADSENSE_SCRIPT = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

function loadAdsense() {
  if (!document.querySelector(`script[src="${ADSENSE_SCRIPT}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = ADSENSE_SCRIPT;
    document.head.appendChild(script);
  }
}

export default {
  props: {
    adClient: {
      type: String,
      required: true,
    },
    adSlot: {
      type: String,
      required: true,
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto',
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block',
    },
  },
  mounted() {
    loadAdsense();
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  },
};
</script>

